import { useEffect } from 'react';
import { Icon } from '../../../layout/Icon.jsx';
import { useWebcam } from '../../../shared/useWebcam.js';

export function PhotoCapture({ photoUrl, onCapture, onClear }) {
  const { videoRef, ready, start, stop, snapshot, error } = useWebcam();

  useEffect(() => {
    if (!photoUrl) start();
    return () => stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photoUrl]);

  const take = async () => {
    const blob = await snapshot();
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    onCapture?.(blob, url);
    stop();
  };

  return (
    <div>
      <label className="block text-xs font-semibold text-ink-2 mb-1.5">صورة الطفل</label>
      <div
        className="aspect-square rounded-[14px] overflow-hidden relative grid place-items-center"
        style={{ border: '2px dashed #D6CCB3', background: '#FAF6EE' }}
      >
        {photoUrl ? (
          <img src={photoUrl} alt="طفل" className="w-full h-full object-cover" />
        ) : error ? (
          <div className="text-center text-ink-3 p-3">
            <Icon name="camera" size={36} color="#EF4444" />
            <div className="text-[11px] mt-1.5 text-red">{error}</div>
          </div>
        ) : (
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            className="w-full h-full object-cover"
            style={{ display: ready ? 'block' : 'none' }}
          />
        )}
        {!photoUrl && !ready && !error ? (
          <div className="absolute inset-0 grid place-items-center text-ink-3 pointer-events-none">
            <div className="text-center">
              <Icon name="camera" size={36} color="#9CA3AF" />
              <div className="text-[11px] mt-1.5">جاري تشغيل الكاميرا...</div>
            </div>
          </div>
        ) : null}
        {photoUrl ? (
          <div
            className="absolute top-2 left-2 text-white text-[10px] font-bold px-2 py-0.5 rounded"
            style={{ background: '#22C55E' }}
          >
            تم
          </div>
        ) : null}
      </div>
      <div className="mt-2 flex gap-2">
        {photoUrl ? (
          <button
            type="button"
            className="btn flex-1 justify-center"
            onClick={() => {
              onClear?.();
            }}
          >
            <Icon name="camera" size={14} /> إعادة التقاط
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-primary flex-1 justify-center"
            disabled={!ready}
            onClick={take}
          >
            <Icon name="camera" size={14} /> التقط صورة
          </button>
        )}
      </div>
    </div>
  );
}
